import { useState, useEffect, useMemo } from "react";
import { modifyCategory } from "../functions/filter/modifyCategory";
import sortDataByAlphabetically from "../functions/sorting/sortDataByAlphabetically";

const useFilterOptionManager = ({
  category,
  optionList,
  valueAddress,
  setSelectedItems,
  unsort,
}) => {
  const [searchList, setSearchList] = useState([]);
  const [optionArr, setOptionArr] = useState([]);
  let modifiedCategory = modifyCategory(category);

  const handleSearch = (e) => {
    let val = e.target.value.trim();
    if (val.length > 0) {
      const filteredItems = optionList.filter((item) => {
        let optItem = item.label?.toString()?.toLowerCase();
        return (
          optItem?.includes(val.toLowerCase()) ||
          optionArr.includes(item.value?.toString()?.toLowerCase())
        );
      });
      setSearchList(filteredItems); // Update searchList with filtered items
    } else {
      const sortedOptions =
        sortDataByAlphabetically(optionList, ["label"]) || [];
      setSearchList(sortedOptions);
    }
  };

  const handleCheckbox = (e) => {
    let value = e.target.value;
    setSelectedItems((prev) => {
      const currentCategory = prev[modifiedCategory]?.val || [];
      const newArr = currentCategory.includes(value)
        ? currentCategory.filter((option) => option !== value)
        : [...currentCategory, value];

      // Create a new object without modifying the previous state directly
      const newState = { ...prev };

      if (newArr.length === 0) {
        // Remove the key if val is empty
        delete newState[modifiedCategory];
      } else {
        // Update the key if val is not empty
        newState[modifiedCategory] = { val: newArr, address: valueAddress };
      }

      return newState;
    });
    setOptionArr((prev) => {
      const newArr = prev.includes(value)
        ? prev.filter((option) => option !== value)
        : [...prev, value];
      return newArr;
    });
  };

  useEffect(() => {
    const sortedOptions = unsort
      ? optionList
      : sortDataByAlphabetically(optionList, ["label"]) || [];
    setSearchList(sortedOptions);
  }, [optionList, unsort]);

  return { handleSearch, handleCheckbox, searchList };
};

export default useFilterOptionManager;
